import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
   body{
      margin: 0px;
      font-family: "Inter", sans-serif;
      font-size: 18px;
      
         @media screen and (max-width: 1000px){
               font-size: 14px;
         }
      }
 `

 export default GlobalStyle;